<template>
    <div class="evaluate">
        <div class="flex wrap nav">
            <div class="flex__center__center nav__item" :class="loads.index==index?'active':''" v-for="(item,index) in classify" :key="index" @click="loads.index=index">
                <span class="fs_24" :class="loads.index==index?'c_main':'c_66'">{{item.sub_classify}}({{item.num}})</span>
            </div>
        </div>
        <!-- 评价 -->
        <div class="evaluate-box">
            <div class="evaluate__item" v-for="(item,index) in list" :key="index">
                <div class="flex item__header">
                    <img :src="item.headimgurl" alt="">
                    <div class="flex__null__around ml_20">
                        <span class="fs_30 c_name">{{item.nickname}}</span>
                        <div> 
                            <span class="fs_26 c_98">{{item.create_time}}</span>
                            <span class="fs_26 c_98" v-if="item.product_sku_name">&emsp;规格:{{item.product_sku_name}}</span>
                        </div>
                    </div>
                </div>
                <p class="fs_30 c_1a mt_20 lh_40" v-if="item.content">{{item.content}}</p>
                <div class="flex wrap item__img" v-if="item.img_path.length">
                    <img :src="item1" alt="" v-for="(item1,index1) in item.img_path" :key="index1" @click="previewImage(index,index1)">
                </div>
                <div class="item__reply" v-if="item.is_replay==2">
                    <span class="fs_26 c_80 lh_36">掌柜回复：{{item.replay}}</span>
                </div>
            </div>
        </div>
        <jc-list :url="'/Mall/getProductReviewList'" :loads="loads" @load='getList'></jc-list>
    </div>
</template>
<script>
export default {
    name: 'Evaluate',
    data(){
        return{
            loads:{
                product_id:'',
                index:0
            },
            list:[],
            review:{},
            classify: [{
                id: 1,
                sub_classify: "全部",
                num: 0
            },
            {
                id: 2,
                sub_classify: "有图",
                num: 0
            }, {
                id: 3,
                sub_classify: "好评",
                num: 0
            }, {
                id: 4,
                sub_classify: "中评",
                num: 0
            }, {
                id: 5,
                sub_classify: "差评",
                num: 0
            }]
        }
    },
    methods:{
        getList (data) { 
            this.list=data;
        },
        // 查看大图
        previewImage(index,index1){
            this.$wx.previewImage({
                url: this.list[index].img_path[index1],
                urls: this.list[index].img_path
            })
        }
    },
    mounted(){
        this.loads.product_id=this.$route.params.id;
        this.axios.post('/wechat.php/Mall/getProductReviewData',{
            product_id:this.$route.params.id
        }).then(
            res=>{
                if(res.data.code==1){
                    this.classify[0].num = res.data.data.review.all_count;
                    this.classify[1].num = res.data.data.review.has_img_count;
                    this.classify[2].num = res.data.data.review.goods_review_count;
                    this.classify[3].num = res.data.data.review.middle_review_count;
                    this.classify[4].num = res.data.data.review.bad_review_count;
                }
            }
        )
    }
}
</script>

<style scoped>
/* 选项卡 */
.nav{
    padding: 20px 30px 30px;
    background: #fff;
    border-bottom: 2px solid #e6e6e6;
}
.nav__item{
    width: 165px;
    height: 50px;
    margin: 10px 0 0 10px;
    border-radius: 4px;
    background: #f5f5f5;
}
.nav__item:nth-child(4n+1){
    margin-left: 0;
}
.nav__item.active{
    background: #FFEEED;
    border: 2px solid #F93A42;
}
/* 评价 */
.evaluate-box{
    background: #fff;
}
.evaluate__item{
    padding: 30px;
    border-bottom: 2px solid #e6e6e6;
}
.evaluate__item:last-child{
    border: 0;
}
.item__header img{
    width: 80px;
    height: 80px;
    border-radius: 50%;
}
.item__img{
    margin-top: 20px;
    padding-bottom: 30px;
}
.item__img img{
    width: 165px;
    height: 165px;
    margin: 10px 0 0 10px;
}
.item__img img:nth-child(4n+1){
    margin-left: 0;
}
.item__reply{
    padding: 10px 20px;
    background: #f5f5f5;
    border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/mall/EvaluateList.vue